import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';
import React, { useState } from 'react';

const useStyles = makeStyles({
    dashboardserviceicons: (props) => ({
        padding: '15px',
        borderRadius: '3px',
        '&:hover': {
            background: `${props.hoverColor} !important`,
            color: '#fff'
        }
    })
});
const BBPSIcon = (props) => {
    return (
        <div>
            <svg
                version="1.0"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 204.63 225"
                style={{
                    enableBackground: 'new 0 0 380.9 454',
                    marginTop: '10px',
                    marginBottom: '15px',
                    width: '20%'
                }}
            >
                <style>
                    {`
                        .st0 { fill: black; }
                        .st1 { fill: #4267B2; }
                        .st2 { fill: #4267B2; }
                    `}
                </style>
                <g>
                    <g>
                        <path
                            className="st1"
                            d="M149.36,67.66c0,1.99-0.06,3.94-0.19,5.81c-0.12,1.87-0.53,4.33-1.2,7.4c-0.68,3.06-1.57,5.87-2.68,8.43 			c-1.1,2.56-2.73,5.25-4.89,8.06c-2.15,2.82-4.7,5.15-7.66,7.03c-2.95,1.87-6.7,3.43-11.25,4.68c-4.55,1.25-9.65,1.88-15.31,1.88 			H61.3c-3.32,0-6.01-2.73-6.01-6.11V87.65h0.02c6.94,0,15.68,0,24.82-0.01h27.28c3.49,0,6.13-1.75,7.44-4.92 			c1.29-3.12,0.68-6.19-1.74-8.66c-8.57-8.75-17.23-17.54-25.31-25.72c-1.86-1.89-4.18-2.66-6.7-2.24 			c-3.07,0.52-5.22,2.35-6.19,5.28c-1,3.05-0.34,5.88,1.92,8.2c3.31,3.38,6.65,6.75,10.14,10.27l1.91,1.94H55.28l-0.01-43 			c0.01-3.36,2.69-6.09,6-6.09h44.91c12.17,0,22.41,4.03,30.71,12.09C145.21,42.83,149.36,53.8,149.36,67.66z"
                        />
                        <path
                            className="st2"
                            d="M149.36,159.02c0,1.99-0.06,3.94-0.19,5.81c-0.12,1.87-0.53,4.33-1.2,7.4c-0.68,3.06-1.57,5.87-2.68,8.43 			c-1.1,2.56-2.73,5.25-4.89,8.06c-2.15,2.81-4.7,5.15-7.66,7.03c-2.95,1.87-6.7,3.43-11.25,4.68c-4.55,1.25-9.65,1.88-15.31,1.88 			H61.3c-3.32,0-6.01-2.73-6.01-6.11v-8.72l-0.01-67.35c0.01-3.36,2.69-6.09,6-6.09h44.91c12.17,0,22.41,4.03,30.71,12.09 			c3.56,3.47,6.37,7.46,8.41,12c-6.32,0-14.15,0-22.43,0.01H93.01c-3.49,0-6.13,1.74-7.45,4.92c-1.28,3.12-0.67,6.2,1.75,8.66 			c8.51,8.69,17.2,17.5,25.31,25.72c1.53,1.55,3.36,2.35,5.37,2.35c0.44,0,0.88-0.04,1.34-0.12c3.07-0.52,5.22-2.35,6.19-5.29 			c1-3.04,0.34-5.87-1.93-8.19c-3.31-3.39-6.65-6.76-10.15-10.28l-1.89-1.92h37.61C149.29,155.64,149.36,157.31,149.36,159.02z"
                        />
                    </g>
                </g>
            </svg>
            <h6>{props.name}</h6>
        </div>
    );
};

export default BBPSIcon;
